import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { authApi, isAuthenticated } from "@/lib/api";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      if (!isAuthenticated()) {
        navigate(`/auth/login?redirect=${encodeURIComponent(location.pathname)}`, { replace: true });
        return;
      }

      try {
        await authApi.me();
        if (cancelled) return;
        setAuthenticated(true);
      } catch {
        if (!cancelled) {
          navigate(`/auth/login?redirect=${encodeURIComponent(location.pathname)}`, { replace: true });
        }
      } finally {
        if (!cancelled) setChecking(false);
      }
    };

    check();

    return () => {
      cancelled = true;
    };
  }, [navigate, location.pathname]);

  if (checking) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line animate-spin text-3xl text-primary-500 w-8 h-8 flex items-center justify-center"></i>
          <span className="text-foreground-500 text-sm">인증 확인 중...</span>
        </div>
      </div>
    );
  }

  if (!authenticated) return null;

  return <>{children}</>;
}